import { render, staticRenderFns } from "./WidgetWelcomeMessage.vue?vue&type=template&id=1d42b6e2&scoped=true&"
import script from "./WidgetWelcomeMessage.vue?vue&type=script&lang=ts&"
export * from "./WidgetWelcomeMessage.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetWelcomeMessage.vue?vue&type=style&index=0&id=1d42b6e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d42b6e2",
  null
  
)

export default component.exports